<span class="pcg-entry-description">{{ pcgEntry | pcgEntryDescription }}</span>
@if (pcgEntry.archived) {
  <mat-icon class="icon" svgIcon="icon-archived" color="primary"></mat-icon>
}
